const messages = {
  //category
  "affiliation.info.title": "عنوان",
  "affiliation.info.webLink": "وب‌سایت",
  "affiliation.info.email": "آدرس ایمیل",
  "affiliation.info.webLinkShort": "لینک کوتاه",
  "affiliation.info.address": "آدرس ",
  "affiliation.info.googleMap": "موقعیت در نقشه گوگل",
  "affiliation.info.province": "استان",
  "affiliation.query.sciVal": "کلیدواژه SciVal",
  "affiliation.query.scopusId": "شناسه اسکوپوس",
  "affiliation.query.scopusQuery": "Scopus Affiliation Query",
  "affiliation.query.wosQuery": "کوئری WoS",
  "affiliation.query.wosId": "شناسه WoS",

  "affiliation.l10n.name.fa": "نام",
  "affiliation.l10n.nameShort.fa": "نام اختصاری",
  "affiliation.l10n.abbrText.fa": "کد اختصاری",
  "affiliation.l10n.subjectAreas.fa": "برچسب‌های موضوعی",
  "affiliation.l10n.introText.fa": "معرفی",

  "affiliation.l10n.name.en": "Name",
  "affiliation.l10n.nameShort.en": "Short name",
  "affiliation.l10n.abbrText.en": "Abbreviation code",
  "affiliation.l10n.subjectAreas.en": "Subject tags",
  "affiliation.l10n.introText.en": "Introduction",

  "affiliation.level2.types": "دسته بندی مرکز آموزشی",
  "affiliation.level3.types": "حوزه موضوعی دانشکده یا پژوهشکده",
  "affiliation.level4.types": "حوزه موضوعی گروه های آموزشی",
  "affiliation.level0.name": "نام هیات علمی یا پژوهشگر",
  "affiliation.info.rankId0": "مرتبه علمی",
  "affiliation.info.rankId2": "سطح بندی وزارت علوم",
  "affiliation.info.rankId3": "",
  "affiliation.info.rankId4": "",
};

export default messages;
